import { Injector, NgModule, PlatformRef } from '@angular/core';
import { RouterModule } from '@angular/router';

import { resetAppInjector, setAppInjector } from '@frontend/sports/host-app/sports-product/feature/utils';
import { ClientConfigProductName, ProductService } from '@frontend/vanilla/core';

import { INTERNAL_ESPORTS_ROUTES } from '../esports-web-internal.routes';
import { provideSportsWebCore } from '../provide';
import { SportRoute } from '../router/multi-route.model';
import { NoMatchRouteGuard } from '../router/no-match-route.guard';
import { SeoRedirectGuard } from '../seo/seo-redirect.guard';
import { INTERNAL_SPORTS_WEB_ROUTES } from '../sports-web-internal.routes';
import { sportsWebProductActivateGuard, sportsWebProductDeactivateGuard } from './guards';
import { provideSportsWebHostApp } from './sports-web-host-app.provider';

const SPORTS_WEB_ROUTES: SportRoute[] = [
    {
        path: '',
        canMatch: [sportsWebProductActivateGuard],
        canDeactivate: [sportsWebProductDeactivateGuard],
        children: [
            ...INTERNAL_SPORTS_WEB_ROUTES,
            {
                path: '{esports}',
                children: [...INTERNAL_ESPORTS_ROUTES],
            },
            {
                path: '**',
                loadComponent: () => import('../common/empty.component').then((m) => m.EmptyComponent),
                canActivate: [NoMatchRouteGuard, SeoRedirectGuard],
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(SPORTS_WEB_ROUTES)],
    providers: [provideSportsWebCore(), provideSportsWebHostApp()],
})
export class SportsWebIntegrationModule {
    constructor(injector: Injector, platformRef: PlatformRef) {
        injector.get(ProductService).register(ClientConfigProductName.SPORTS, injector);
        setAppInjector(injector);
        platformRef.onDestroy(() => resetAppInjector());
    }
}
